const headerNavLinks = [
  { href: '/blog', title: 'Blog' },
  { href: '/tags', title: 'Tags' },
  // { href: '/projects', title: 'Projects' },
  { href: '/about', title: 'About' },
]

export default headerNavLinks
